import { useEffect } from "react";
import type { ThemeMode } from "@/api/types/ThemeMode";

const STORAGE_KEY = "mixla-theme";
const darkQuery = () => window.matchMedia("(prefers-color-scheme: dark)");

function apply(mode: ThemeMode) {
  const dark = mode === "dark" || (mode === "system" && darkQuery().matches);
  document.documentElement.dataset.mode = dark ? "dark" : "light";
}

/** Applies a theme mode to <html> and keeps `system` in sync with the OS. */
export function useThemeMode(mode: ThemeMode) {
  useEffect(() => {
    apply(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // storage unavailable
    }
    if (mode !== "system") return;
    const q = darkQuery();
    const onChange = () => apply("system");
    q.addEventListener("change", onChange);
    return () => q.removeEventListener("change", onChange);
  }, [mode]);
}
